exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-message[data-v-0746db3d]{border:1px dashed red;text-align:center;padding:10px;margin-top:10px;color:red;margin-bottom:10px}.form-control[data-v-0746db3d]{background-color:#fff!important}.text-xl[data-v-0746db3d]{font-size:20px;font-weight:700}.text-lg[data-v-0746db3d]{font-size:16px;font-weight:700}.text-md[data-v-0746db3d]{font-size:14px;color:green}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./src/components/paywall/users/ApproveIpRangesConfig.vue?vue&type=style&index=0&id=0746db3d&prod&scoped=true&lang=css&
// module id = 1468
// module chunks = 0